module.exports = __webpack_public_path__ + "static/media/trainVideo5.388134c1.m4v";